export const BILLING_PERIODS: Record<string, string> = {
  day_1: 'Daily',
  month_1: 'Monthly',
  year_1: 'Annual (17% off)',
  year_3: 'Every 3 Years',
};